import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "cla-claim-header-logo",
  templateUrl: "./claim-header-logo.component.svg",
  styleUrls: ["./claim-header-logo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClaimHeaderLogoComponent {}
